var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51888 9.78288H11.1022V6.008C11.1022 3.90471 9.40463 2.19954 7.31055 2.19954C5.21646 2.19954 3.51888 3.90471 3.51888 6.008V9.78288ZM7.31055 1.11621C10.0026 1.11621 12.1855 3.30617 12.1855 6.008V10.8662H2.43555V6.008C2.43555 3.30617 4.61846 1.11621 7.31055 1.11621ZM5.95638 11.4079H8.66471C8.66471 11.767 8.52204 12.1115 8.26809 12.3654C8.01413 12.6194 7.66969 12.762 7.31055 12.762C6.9514 12.762 6.60696 12.6194 6.35301 12.3654C6.09905 12.1115 5.95638 11.767 5.95638 11.4079Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.c34348b1c43ef3701c2c9e595def5802.svg";
export { ForwardRef as ReactComponent };